/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/play';
import { PLAY } from '@/store/types';
import { finalizeAction } from '@/store/actions';
import { PlayService } from '@/api/types/play';

export interface StorePlayServiceOtherState {
  id: number;
  services: PlayService[];
}

export default {
  namespaced: true,
  state: {
    id: null,
    services: null,
  },
  getters: {},
  actions: {
    [PLAY.GET_SERVICES]({ state, commit }, { action: rawAction, id, silent }) {
      const action = finalizeAction(rawAction, state.id === id);
      if (action) {
        return new Promise((resolve, reject) => {
          api.getUserServices(id, silent).then((res) => {
            commit(PLAY.GET_SERVICES, { id, data: res.data });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [PLAY.GET_SERVICES](state, { id, data }) {
      state.id = id;
      state.services = data;
    },
  },
};
